function addToCart(t) {
    "undefined" != typeof t && t.preventDefault();
    var e = $(this),
        o = e.closest("form");
    if (0 == o.serialize().length) {
        var i = e.parents(".product-information");
        o = i.find("form.product-actions")
    }
    return window.ajax_add_to_cart ? void $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        data: o.serialize(),
        dataType: "json",
        beforeSend: function() {
            $("body").addClass("loader");
             $('#popup1').show(200);
        },
        error: function(t) {
     
    
            $('.ajax-error-message').text($.parseJSON(t.responseText).description);
            itgeeks.showModal('.ajax-error-modal');

            setTimeout(function() {
           
                jQuery("body").removeClass("loader");
            }, 500)


        },
        success: function(t) {
            Shopify.getCart(function(e) {
 jQuery('#popup1').delay(10000).fadeOut();
                setTimeout(function() {
                    jQuery("body").removeClass("loader"), itgeeks.timeout = setTimeout(function() {
                        itgeeks.closeThemeControll2()
                    }, 5e3)
                }, 500), Shopify.updateCartInfo(e, ".cart-info")
                        })
        },
        cache: !1
    }) : void o.submit()
}! function(t) {
    function e() {}
    for (var o, i = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","); o = i.pop();) t[o] = t[o] || e
}(function() {
    try {
        return console.log(), window.console
    } catch (t) {
        return window.console = {}
    }
}());
var GLOBAL = {
        common: {
            init: function() {
                $("html").removeClass("no-js").addClass("js"), $("body").on("click", ".addtocart", addToCart)
            }
        }
    },
    UTIL = {
        fire: function(t, e, o) {
            var i = GLOBAL;
            e = void 0 === e ? "init" : e, "" !== t && i[t] && "function" == typeof i[t][e] && i[t][e](o)
        },
        loadEvents: function() {
            var t = document.body.id;
            UTIL.fire("common"), $.each(document.body.className.split(/\s+/), function(e, o) {
                UTIL.fire(o), UTIL.fire(o, t)
            })
        }
    };
$(document).ready(UTIL.loadEvents);